import { Directive, input } from '@angular/core';

export const RichTextEditorFormControlDirectiveInputs = ['height', 'maxLength'];

@Directive({
  selector: '[uiRichTextEditorFormControl]',
  standalone: true,
})
export class RichTextEditorFormControlDirective {
  readonly height = input('10rem');

  readonly maxLength = input<number | null>(null);
}
